import {
  ELEMENT_PRINTSTYLES_ALLOWED,
  PRINT_STYLES_ALL
} from '../../utils/constants';
import each from 'lodash/each';
import intersection from 'lodash/intersection';
import difference from 'lodash/difference';
import union from 'lodash/union';
import map from 'lodash/map';
import { GETTER_FONT_EFFECT, GETTER_FONT_FONT } from './modules/font/getters';
import { GETTER_AVAILABLE_PRINT_STYLES_BY_PRINT_SIDE } from './getters';
import {
  ELEMENT_TYPE_DESIGN,
  ELEMENT_TYPE_TEXT,
  ELEMENT_TYPE_UPLOAD
} from '@/plugins/composition-renderer/constants';

const capabilityMerge = function (...capabilities) {
  const printStylesCapabilities = intersection(
    PRINT_STYLES_ALL,
    ...capabilities
  );
  const otherCapabilities = difference(
    union(...capabilities),
    PRINT_STYLES_ALL
  );

  return [...printStylesCapabilities, ...otherCapabilities];
};

const getAllowedElementsForPrintStyle = printStyle => {
  return map(ELEMENT_PRINTSTYLES_ALLOWED, (printStyles, element) => {
    return printStyles.includes(printStyle) ? element : null;
  }).filter(element => element !== null);
};

export const GETTER_PRINT_PLATE_CAPABILITIES = 'getPrintPlateCapabilites';
export const GETTER_ELEMENT_CAPABILITIES = 'getElementCapabilities';

export default {
  [GETTER_PRINT_PLATE_CAPABILITIES]: (state, getters) => (printPlate, side) => {
    if (!printPlate) {
      return [];
    }
    let printPlateCapabilities = [];

    // PrintPlate Base capabilites:
    printPlateCapabilities.push([
      // Available PrintStyles
      ...getters[GETTER_AVAILABLE_PRINT_STYLES_BY_PRINT_SIDE](side),
      // Allowed Elements for selected print style
      ...getAllowedElementsForPrintStyle(printPlate.printStyle)
    ]);

    each(printPlate.content, element => {
      printPlateCapabilities.push(
        getters[GETTER_ELEMENT_CAPABILITIES](element)
      );
    });
    return capabilityMerge(...printPlateCapabilities);
  },
  [GETTER_ELEMENT_CAPABILITIES]: (state, getters) => element => {
    if (null === element || undefined === element) {
      return [];
    }
    switch (element.type) {
      case ELEMENT_TYPE_TEXT:
        return getters.getTextElementCapabilities(element);
      case ELEMENT_TYPE_DESIGN:
        return getters.getDesignElementCapabilities(element);
      case ELEMENT_TYPE_UPLOAD:
        return getters.getUploadElementCapabilities(element);
    }
    return [];
  },
  // internal getter
  getTextElementCapabilities: (state, getters) => element => {
    return capabilityMerge(
      ELEMENT_PRINTSTYLES_ALLOWED[element.type],
      getters.getFontCapabilites(element),
      getters.getFontEffectCapabilites(element)
    );
  },
  // internal getter
  getDesignElementCapabilities: () => element => {
    return capabilityMerge(ELEMENT_PRINTSTYLES_ALLOWED[element.type]);
  },
  // internal getter
  getUploadElementCapabilities: () => element => {
    return capabilityMerge(ELEMENT_PRINTSTYLES_ALLOWED[element.type]);
  },
  // internal getter
  getFontCapabilites: (state, getters) => element => {
    const font = getters[GETTER_FONT_FONT](element.font);
    if (null === font || !Array.isArray(font.capabilities)) {
      return [];
    }
    return font.capabilities;
  },
  // internal getter
  getFontEffectCapabilites: (state, getters) => element => {
    const effect = getters[GETTER_FONT_EFFECT](element.effect);
    if (null === effect || !Array.isArray(effect.capabilities)) {
      return [];
    }
    return effect.capabilities;
  }
};
